import * as React from 'react'

import * as model from '@owl-nest/models'

import { useStep, Step } from './useStep'
import { Welcome } from './view/Welcome'
import { Profile } from './view/Profile'
import { Category } from './view/Category'
import { CommunityOnboarding } from './view/CommunityOnboarding'
import { ProjectType } from './view/ProjectType'
import { RewardType } from './view/RewardType'
import { Training } from './view/Training'
import { Slug } from './view/Slug'
import { Layout } from './Layout'

type OnboardingProps = {
  project: model.project.ProjectForOwner
}

export function Onboarding({ project }: OnboardingProps): React.ReactElement {
  const { step, isDone } = useStep(project)

  if (isDone) {
    return <></>
  }

  return (
    <Layout project={project} withProgress={step?.key !== Step.WELCOME}>
      {step?.key === Step.WELCOME && <Welcome project={project} />}
      {step?.key === Step.PROJECT_TYPE && <ProjectType project={project} />}
      {step?.key === Step.IMPORT_TYPE && <CommunityOnboarding project={project} />}
      {step?.key === Step.CATEGORY && <Category project={project} />}
      {step?.key === Step.REWARD_TYPE && <RewardType project={project} />}
      {step?.key === Step.TRAINING && <Training project={project} />}
      {step?.key === Step.SLUG && <Slug project={project} />}
      {step?.key === Step.PROFILE && <Profile project={project} />}
    </Layout>
  )
}
